<template>
    <div v-if="isreadshow">
        <my-search @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.txtKey1"  placeholder="单位名称" clearable></el-input>
            </el-form-item>
               <el-form-item slot="time">
                <el-radio-group v-model="pgData.txtKey" @change="searchHandler">
                    <el-radio-button label="0">未回复</el-radio-button>
                    <el-radio-button label="1">已回复</el-radio-button>
                </el-radio-group>
            </el-form-item>
            
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" min-width="220" fixed></el-table-column>
            <el-table-column label="标段编号" prop="bdcode" min-width="220"></el-table-column>
            <el-table-column label="投诉单位名称" prop="tsdwname"></el-table-column>
            <el-table-column label="提交时间" prop="tjtime"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <my-tag type="danger" v-if="scope.row.exthfbj===null||scope.row.exthfbj==='0'">未回复</my-tag>
                    <my-tag type="success" v-else>已回复</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <div v-if="scope.row.exthfbj===null||scope.row.exthfbj==='0'">
                        <my-btn type="edit" @click="edit(scope.row.tscode)">回复</my-btn>
                    </div>
                    <div v-else>
                        <my-btn type="edit" @click="edit(scope.row.tscode)">追加回复</my-btn>
                        <my-btn type="detail" @click="detail(scope.row.tscode)">详情</my-btn>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/bidding/yygl/tslist.json`"></my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
  
    data() {
        return{
            pgData:{
                procode:'',
                sortname : 'tscode',
                txtKey: '0',
                txtKey1: '',           
            },
            form:{
            },
            isreadshow:true,
            tableData:[]
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //详情
        detail:function(id){
            this.goto({
                path:'./detail',
                query:{
                    procode:this.pgData.procode,
                    id:id
                }
            });
        },
        //修改
        edit:function(id){
            this.goto({
                path:'./edit',
                query:{
                    procode:this.pgData.procode,
                    id:id
                }
            });
        }
    },
    created() {
        if(this.getQuery('zbr')==='keda') {
            this.pgData.zbr = 'keda'
        }
        if(this.getQuery('procode')!=undefined){
            this.pgData.procode=this.getQuery('procode')
        }
        this.jspInit(`${this.getGetters('bidUrl')}/bidding/yygl/tslistinit.json`,
            {
                procode:this.pgData.procode
                
            },
                data => { 
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
